import { styled } from "@mui/system"
import { Box, TableCell } from "@mui/material"

export const HeaderCell = styled(TableCell)({
  fontSize: "14px",
  color: "var(--grey-grey-07)",
  fontWeight: "400",
  lineHeight: "20px",
  letterSpacing: "0.25px",
})

export const BodyCell = styled(TableCell)({
  textAlign: "right",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  border: 'none',
  padding: '16px'
})

const nestedCell: React.CSSProperties = {
  textAlign: "right",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  margin: 0,
  padding: 0,
  border: 0,
  minWidth: "100px",
  maxWidth: "100px",
  paddingRight: "5%",
};

export const NestedHeaderCell = styled(TableCell)({
  ...nestedCell,
  color: "var(--grey-grey-07)",
  fontSize: "14px",
})

export const NestedBodyCell = styled(TableCell)({
  ...nestedCell,
  fontSize: "16px",
})

export enum CellContentVariant {
  RED = "RED",
  GREY = "GREY",
  LIGHTGREY = "LIGHTGREY",
}

export const CellContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== "variant",
})<{ variant?: CellContentVariant }>(({ variant }) => ({
  paddingBottom: "0px",
  fontSize: '14px',
  color: "var(--brand-text-default)"
}))
